import { FunctionComponent, PropsWithChildren } from "react";
import { FallbackProps } from "react-error-boundary";

import { Button, Stack } from "@mui/material";

import { ErrorBox } from "./ErrorBox";

// How Chrome/Edge, Firefox and Safari report a failed lazy import, e.g. when a
// deploy has removed the chunk the open page still points to
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

const isChunkLoadError = (error: unknown) =>
  error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);

export const ErrorBoundaryFallback: FunctionComponent<
  PropsWithChildren<FallbackProps>
> = ({ error, resetErrorBoundary, children }) => {
  if (!error) {
    return <>{children}</>;
  }

  // React keeps a failed lazy import, so only a reload can load the new version
  const isNewVersion = isChunkLoadError(error);

  return (
    <Stack spacing={2}>
      {isNewVersion ? (
        <ErrorBox title="A new version of Best Health is available. Please reload the page." />
      ) : (
        <ErrorBox error={error} />
      )}
      <Stack direction="row" spacing={2}>
        {!isNewVersion && (
          <Button variant="outlined" onClick={resetErrorBoundary}>
            Try again
          </Button>
        )}
        <Button variant="contained" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </Stack>
    </Stack>
  );
};
